export const backendDeTranslations = {
  'cost center belongs to another organisation':
    'Die Kostenstelle gehört zu einer anderen Organisation',
}
